import {commitMutation, graphql} from 'react-relay';
import type {Environment, Disposable} from 'relay-runtime';
import {csrfToken, socketClientId} from '../../../forecast-app/ticketing/graphql/forecastRelay';
import type {markTicketNotificationReadMutation} from './__generated__/markTicketNotificationReadMutation.graphql';

const mutation = graphql`
	mutation markTicketNotificationReadMutation($input: MarkTicketNotificationReadInput!) {
		markTicketNotificationRead(input: $input) {
			notification {
				id
				read
			}
		}
	}
`;

function commit(
	environment: Environment,
	notificationId: string,
	onCompleted?: (r: markTicketNotificationReadMutation['response']) => void,
	onError?: (e: Error) => void
): Disposable {
	return commitMutation<markTicketNotificationReadMutation>(environment, {
		mutation,
		variables: {
			input: {csrfToken: csrfToken(), socketClientId: socketClientId(), notificationId},
		},
		optimisticResponse: {
			markTicketNotificationRead: {notification: {id: notificationId, read: true}},
		} as never,
		onCompleted: onCompleted ? response => onCompleted(response) : undefined,
		onError: onError ? error => onError(error) : undefined,
	});
}

export default {commit, mutationId: 'markTicketNotificationReadMutation'};
